import { render, staticRenderFns } from "./DocumentClosedItem.vue?vue&type=template&id=4a04a522&"
import script from "./DocumentClosedItem.vue?vue&type=script&lang=js&"
export * from "./DocumentClosedItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentClosedItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports